var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeaWave5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1905 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1905 59c-22 5-46 9-73 9-117 0-125-57-219-57-93 0-188 57-262 57-17 0-127-64-217-64-185 0-223 61-325 60-51-18-94-60-190-60-124 0-174 64-292 64-117 0-125-57-219-57-36 0-72 9-108 19v199h1905V59z",
    fill: "#25A8C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1000 19a1040 1040 0 0169-11 450 450 0 01138 9l32 10 16 6 8 3 8 2c-38-16-79-37-154-37-47 0-83 8-117 18zM506 23l8-1 8-2a505 505 0 01117-9 309 309 0 0196 21l15 6 8 2 8 3C729 27 690 5 618 5c-46 0-80 9-112 18z",
    fill: "#69BCB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeaWave5);
export default __webpack_public_path__ + "static/media/sea-wave-5.d29a172a2967004c61f054d5e178f029.svg";
export { ForwardRef as ReactComponent };